import React from 'react';
import { useFeatureFlagsLD } from 'modules/FeatureFlagsLD/FeatureFlagsProviderLD';
import { ToggleFormComponent } from './FormComponents/ToggleFormElement';
import { MaxNumberFormElement } from './FormComponents/MaxNumberFormElement';
import { EmbedModelVersionIdFormElement } from './FormComponents/EmbedModelVersionIdFormElement';
import { TextInputFormElement } from './FormComponents/TextInputFormElement'; // shouldn't need template options for this
import { PythonFormElement } from './FormComponents/PythonFormElement'; // shouldn't need template options for this
import { RangeSliderFormElement } from './FormComponents/RangeSliderFormElement';
import { TrainTemplateFormElement } from './FormComponents/TrainTemplateFormElement';
import { ConceptFormElement } from './FormComponents/ConceptFormElement/ConceptsFormElement';
import { SelectEnumFormElement } from './FormComponents/SelectEnumFormElement';
import { JSONInputFormElement } from './FormComponents/JSONInputFormElement';
import { AnnotationUserIdFormElement } from './FormComponents/AnnotationUserFormElement/AnnotationUserIdFormElement';
import { ResultsPerQueryFormElement } from './FormComponents/ResultsPerQueryFormElement';
import { DatasetValidation } from './FormComponents/DatasetValidationElement/DatasetValidationFormElement';
import { ApiFormModal } from './FormComponents/ApiFormModal/ApiFormModal';
import { SelectConceptsButton } from './FormComponents/SelectConceptModal/SelectConceptsButton';

export type FormComponentRendererProps = React.InputHTMLAttributes<HTMLInputElement> & {
  field?: CF.API.Models.ModelTypeFieldsEntity;
  fieldType: number;
  path: string;
};

export const FormComponentRenderer = React.memo(
  ({ fieldType, ...rest }: FormComponentRendererProps) => {
    const { thirdPartyApiKeyAvailableLDFF } = useFeatureFlagsLD();
    const FieldTypeMap = (): Record<number, JSX.Element> => ({
      1: <ToggleFormComponent {...rest} />,
      2: <TextInputFormElement {...rest} />,
      3: <MaxNumberFormElement {...rest} />,
      4: <ConceptFormElement {...rest} />,
      5: <SelectConceptsButton {...rest} />,
      7: <RangeSliderFormElement {...rest} />,
      8: <SelectEnumFormElement {...rest} />,
      9: <AnnotationUserIdFormElement {...rest} />,
      10: <JSONInputFormElement {...rest} />,
      11: <ResultsPerQueryFormElement {...rest} />,
      12: <EmbedModelVersionIdFormElement {...rest} />,
      13: <TextInputFormElement {...rest} />,
      14: <TrainTemplateFormElement {...rest} />,
      15: <PythonFormElement {...rest} />,
      19: <DatasetValidation {...rest} />,
      21: thirdPartyApiKeyAvailableLDFF ? <ApiFormModal {...rest} /> : <></>,
    });

    return FieldTypeMap()[fieldType] || null;
  },
  (props, newProps) => {
    return props.path !== newProps.path || props.fieldType !== newProps.fieldType;
  },
);
